import { OnInit, ElementRef } from '@angular/core';
var AutofocusDirective = /** @class */ (function () {
    function AutofocusDirective(hostElement) {
        this.hostElement = hostElement;
        this.focus = true;
    }
    Object.defineProperty(AutofocusDirective.prototype, "autofocus", {
        set: function (value) {
            this.focus = value === true || value === 'true' || value === '';
        },
        enumerable: true,
        configurable: true
    });
    AutofocusDirective.prototype.ngOnInit = function () {
        var _this = this;
        if (this.focus) {
            setTimeout(function () {
                var input = _this.hostElement.nativeElement;
                input.focus();
                input.setSelectionRange(0, 0);
            }, 0);
        }
    };
    return AutofocusDirective;
}());
export { AutofocusDirective };
